import script from "./VColumnControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./VColumnControl.vue?vue&type=script&setup=true&lang=ts"

import "./VColumnControl.vue?vue&type=style&index=0&id=0d1ae983&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1ae983"]])

export default __exports__